import { memo } from 'react';
import { Stack, Text, Box, Flex, Image } from '@chakra-ui/react';

import aiIcon from '@/assets/icon/ai-icon.svg';
import { Screening } from '@/types/Screening';

interface ScreeningQNAsSectionProps {
  screening: Screening;
}

const ScreeningQNAsSection = memo(({ screening }: ScreeningQNAsSectionProps) => {
  return (
    <Stack>
      <Text color="neutrals.900" fontSize="18px" fontWeight="semibold" mb="20px">
        Interview Q&As
      </Text>
      {screening.questions.map((question, index) => (
        <Box key={index} mb="24px" pr="12px">
          <Text fontSize="16px" fontWeight="semibold" color="neutrals.800" mb="12px">
            Q{index + 1}: {question.question}
          </Text>
          {question.answer_text !== '' ? (
            <>
              <Text fontSize="16px" color="neutrals.700" mb="12px">
                <Text as="span" fontWeight="semibold">
                  A:{' '}
                </Text>
                {question.answer_text}
              </Text>
              <Flex mb="12px">
                <Image src={aiIcon} w="20px" h="20px" alt="AI Icon" />
                <Box color="neutrals.900" fontSize="16px" fontWeight="semibold" ml="8px">
                  AI Feedback
                </Box>
              </Flex>
              <Text fontSize="16px" color="neutrals.700" mb="24px">
                {question.feedback}
              </Text>
            </>
          ) : (
            <Text fontSize="16px" color="neutrals.500" mb="24px">
              No answer provided.
            </Text>
          )}

          {index < screening.questions.length - 1 && (
            <Box borderBottom="1px solid" borderColor="neutrals.200" />
          )}
        </Box>
      ))}
    </Stack>
  );
});

ScreeningQNAsSection.displayName = 'ScreeningQNAsSection';

export default ScreeningQNAsSection;
